
import { ApprovalIcon, EnvironmentIcon, MaintenanceIcon, PagesIcon } from "allIcons";

export const featureMenu = (web) => {
  return [
    {
      module: "environments",
      title: "siteTemplate.menu.environments",
      icon: <EnvironmentIcon />,
    },
    web && {
      module: "maintenance",
      title: "siteTemplate.menu.maintenance",
      icon: <MaintenanceIcon />,
    },
    {
      module: "pages",
      title: "Pages",
      icon: <PagesIcon />,
    },
    {
      module: "approvals",
      title: "siteTemplate.menu.approvals",
      icon: <ApprovalIcon />,
    },
  ].filter(_ => _);
};
